export default function gigyaExpand(type) {
  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'gigya_expand',
      event_category: 'gigya',
      event_action: 'expand',
      event_label: type || null,
    },
  ]);
}
